import React from 'react'
import { Wrapper } from './styles'

const Container = ({
  constrainWidth = true,
  disableGutter = false,
  component = 'div',
  adjustPageContainerForMenu,
  ...rest
}) => {
  return (
    <Wrapper
      as={component}
      disableGutter={disableGutter}
      constrainWidth={constrainWidth}
      $adjustPageContainerForMenu={adjustPageContainerForMenu}
      {...rest}
    />
  )
}

export default Container
